export const environment = {
    production: true,
    urlPages:'https://api-dclaims-comercia.azurewebsites.net/',
    urlWS:'https://api-dclaims-comercia.azurewebsites.net/',
    urlWSLanguages:'https://api-dclaims-comercia.azurewebsites.net/',
    logOutUrl:'',
    allowRecoverPassword:true,
    allowHelp : true,
    entity: 'Comercia'
};
